import * as React from 'react';
import cx from 'clsx';
import sharedStyles from './shared-groups.module.css';
import styles from './benefits-group.module.css';
import { TextWithHighlights } from './text-with-highlights.tsx';

interface BenefitsGroupProps {
  title: string;
  benefits: { description: string; isIncluded: boolean }[];
}

export function BenefitsGroup({ title, benefits }: BenefitsGroupProps): React.ReactNode {
  return (
    <div data-test-benefit-group={title}>
      <h3 className={cx('body-prominent', 'mb-8', sharedStyles.title)} data-test-benefit-title>
        {title}
      </h3>
      <ul className={sharedStyles.list}>
        {benefits.map(({ description, isIncluded }, index) => (
          <li
            className={cx(
              sharedStyles['list-item'],
              styles['list-item'],
              'body-standard',
              isIncluded ? styles.included : styles.excluded,
              'mb-8'
            )}
            data-test-benefit-description={index}
            key={description}
          >
            <div aria-hidden="true" className={cx('mr-16', sharedStyles.image, styles.image)} />
            <TextWithHighlights isHighlighted={false}>{description}</TextWithHighlights>
          </li>
        ))}
      </ul>
    </div>
  );
}
